<template>
    <div>
        <license-overview-alpha
            v-if="isPlanAlpha()"
            :license="license"
            :client="client"
            :license-consumption="licenseConsumption"
            :can-config="canConfig"
            :can-buy-licenses="canBuyLicenses"
            :can-see-bookings="canSeeBookings"
            :can-see-booking-history="canSeeBookingHistory"
            :can-transfer-licenses="canTransferLicenses"
            :parent-user="parentUser"
            :is-admin="isAdmin"
        >
        </license-overview-alpha>

        <license-overview-beta
            v-if="isPlanBeta()"
            :license="license"
            :client="client"
            :license-consumption="licenseConsumption"
            :license-usage="licenseUsage"
            :can-config="canConfig"
        >
        </license-overview-beta>
    </div>
</template>

<script>

export default {
    props: [
        'license',
        'client',
        'licenseConsumption',
        'licenseUsage',
        'canConfig',
        'canBuyLicenses',
        'canSeeBookings',
        'canSeeBookingHistory',
        'isAdmin',
        'parentUser',
        'canTransferLicenses',
    ],

    methods: {
        isPlanAlpha() {
            return this.client.license_plan == 'license_plan_alpha';
        },

        isPlanBeta() {
            return this.client.license_plan == 'license_plan_beta';
        },
    }
}
</script>
